import FormActionButtonsContainerController from './form-action-buttons-container.controller';
import { FormActionButtonsContainerProps } from './form-action-buttons-container.model';

const FormActionButtonsContainer = (props: FormActionButtonsContainerProps) => {
  return <FormActionButtonsContainerController {...props} />;
};

export default FormActionButtonsContainer;
